import Vue from 'vue'

const initState = {
    project: {
        payee_organization_id: null
    },
    ownerOrganization: {
        id: null,
        tax_id_number: null,
        account_number: null,
        account_number_confirmation: null,
        routing_number: null,
        routing_number_confirmation: null,
        masked_tax_id_number: null,
        masked_account_number: null,
        masked_routing_number: null,
        organization_name: null,
        bank_account_type: null,
        payment_type: 2,
        person: {},
        phone: {},
        address: {},
    },
    managerOrganization: {
        id: null,
        tax_id_number: null,
        account_number: null,
        account_number_confirmation: null,
        routing_number: null,
        routing_number_confirmation: null,
        masked_tax_id_number: null,
        masked_account_number: null,
        masked_routing_number: null,
        organization_name: null,
        bank_account_type: null,
        payment_type: 2,
        person: {},
        phone: {},
        address: {},
    },
}

export default {
    namespaced: true,
    state: {
        project: Vue.util.extend({}, initState.project),
        taxId: null,
        programs: [],
        entityTypes: [],
        entitySubTypes: [],
        states: [],
        counties: [],
        roles: [],
        documents: [],
        landlordTerms: [],
        alternativeFundingPrograms: [],
        programId: null,
        ownerOrganization: Vue.util.extend({}, initState.ownerOrganization),
        managerOrganization: Vue.util.extend({}, initState.managerOrganization),
        payeeOrganization: null
    },
    mutations: {
        SET_STATES: (state, states) => state.states = states,
        SET_COUNTIES: (state, counties) => state.counties = counties,
        SET_ROLES: (state, roles) => state.roles = roles,
        SET_PROJECT: (state, project) => state.project = project ? project : Vue.util.extend({}, initState.project),
        SET_PROGRAMS: (state, programs) => state.programs = programs,
        SET_PROGRAM_ID: (state, programId) => state.programId = parseInt(programId),
        SET_LANDLORD_TERMS: (state, landlordTerms) => state.landlordTerms = landlordTerms,
        SET_ALTERNATIVE_FUNDING_PROGRAMS: (state, alternativeFundingPrograms) => state.alternativeFundingPrograms = alternativeFundingPrograms,
        SET_ENTITY_TYPES: (state, value) => state.entityTypes = value,
        SET_ENTITY_SUBTYPES: (state, value) => state.entitySubTypes = value,
        SET_PAYEE_ORGANIZATION_ID: (state, orgId) => {
            if (state.project)
            {
                state.project.payee_organization_id = orgId
            }
        },
        SET_OWNER_ORGANIZATION: (state, ownerOrganization) => state.ownerOrganization = ownerOrganization ? ownerOrganization: Vue.util.extend({}, initState.ownerOrganization),
        SET_OWNER_ORGANIZATION_VALUE(state, payload) {
            state.ownerOrganization[payload.field] = payload.value;
        },
        SET_MANAGER_ORGANIZATION: (state, managerOrganization) => state.managerOrganization = managerOrganization ? managerOrganization: Vue.util.extend({}, initState.ownerOrganization),
        SET_MANAGER_ORGANIZATION_VALUE(state, payload) {
            state.managerOrganization[payload.field] = payload.value;
        },
        SET_PAYEE_ORGANIZATION: (state, payeeOrganization) => state.payeeOrganization = payeeOrganization,
        SET_DOCUMENT: (state, documents) => state.documents = documents,
        SET_TAX_ID: (state, taxId) => state.taxId = taxId,
        DELETE_DOCUMENT_SUCCESS: (state, documentId) => {
            let index = state.documents.findIndex((d) => d.id === documentId)
            state.documents.splice(index, 1)
        },
    },
    actions: {
        updateOwnerValue({ commit }, payload) {
            commit('SET_OWNER_ORGANIZATION_VALUE', payload);
        },
        async initForm({commit}) {
            let r = await axios.get('/api/projects/create');
            commit('SET_STATES', r.data.states);
            commit('SET_ROLES', r.data.roles);
            commit('SET_PROGRAMS', r.data.programs);
            commit('SET_ENTITY_TYPES', r.data.entityTypes);
            commit('SET_ENTITY_SUBTYPES', r.data.entitySubTypes);
            if(r.data.programs.length === 1) {
                commit('SET_PROGRAM_ID', r.data.programs[0].id);
            }
        },

        setProject({commit}, project) {
            commit('SET_PROJECT', project);
            commit('SET_OWNER_ORGANIZATION', project ? project.owner_organization: null);
            commit('SET_MANAGER_ORGANIZATION', project? project.manager_organization: null);
            commit('SET_PAYEE_ORGANIZATION', project? project.payee_organization: null);
            commit('SET_PAYEE_ORGANIZATION_ID', project? project.payee_organization_id: null);
        },

        create({commit}, param) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/projects`, param)
                    .then((res) => {
                        commit('SET_PROJECT', res.data.project);
                        commit('SET_MANAGER_ORGANIZATION', res.data.managerOrganization);
                        commit('SET_OWNER_ORGANIZATION', res.data.ownerOrganization);
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        update({commit}, {id, param}) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/api/projects/${id}`, param)
                    .then((res) => {
                        commit('SET_PROJECT', res.data.project);
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        async fetchProject({commit}, projectId) {
            let r = await axios.get(`/api/projects/${projectId}`);
            commit('SET_PROJECT', r.data);
            return r;
        },

        async deleteProject({commit}, projectId) {
            let r = await axios.delete(`/api/projects/${projectId}`);
            commit('SET_PROJECT', null);
            return r;
        },

        fetchDocument({commit}, projectId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/projects/${projectId}/documents`)
                    .then((res) => {
                        commit('SET_DOCUMENT', res.data)
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        fetchOrgDocument({commit}, orgId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/projects/organization/${orgId}/documents`)
                    .then((res) => {
                        commit('SET_DOCUMENT', res.data)
                        resolve(res.data)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        deleteDocument({commit}, { projectId, documentId}) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/projects/${projectId}/document/${documentId}`)
                    .then((res) => {
                        commit('DELETE_DOCUMENT_SUCCESS', documentId)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        async setPayeeOrganizationId({commit, dispatch, state}, id) {
            if (state.project.id && id)
            {
                let r = await axios.post(`/api/projects/${state.project.id}/set-payee-id`, {organization_id: parseInt(id)});
            }
            commit('SET_PAYEE_ORGANIZATION_ID', id ? parseInt(id): null);
            if (id)
            {
                await dispatch('fetchOrgDocument', id);
            }
        },
    },
    getters: {
        payeeOrganization(state) {
            if(!state.project) {
                return null;
            }
            if(state.payeeOrganization)
                return state.payeeOrganization

            if(state.ownerOrganization && parseInt(state.project.payee_organization_id) == parseInt(state.ownerOrganization.id)) {
                return state.ownerOrganization;
            }

            if(state.managerOrganization && parseInt(state.project.payee_organization_id) == parseInt(state.managerOrganization.id)) {
                return state.managerOrganization;
            }
        },
        w9Documents (state) {
          return state.documents ? state.documents.filter(item => item.file_type === 'w9') : []
        },
        program (state) {
            for(var i in state.programs) {
                if(state.programs[i].id === state.programId) {
                    return state.programs[i];
                }
            }
            return null;
        },
        checkDocuments (state) {
            return state.documents ? state.documents.filter(item => item.file_type === 'void_check') : []
        },
    }
}
